module.exports = __webpack_public_path__ + "assets/speakingPace.e18dc4b5.svg";